<!-- Modal de Errores -->
<div class="modal" id="errorModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-0"></div>
      <div class="modal-body text-center">
        <i class="bi bi-exclamation-circle"></i>
        <h3>Error</h3>
        <p [innerHTML]="errorMessage"></p>
      </div>
      <div class="modal-footer border-0 justify-content-center d-flex">
        <!-- CAMBIAR: de cancelActionHandler() a confirmActionHandler() -->
        <button type="button" class="btn btn-generalGris" (click)="confirmActionHandler()">Aceptar</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Alertas -->
<div class="modal" id="alertModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-0"></div>
      <div class="modal-body text-center">
        <i class="bi bi-exclamation-circle"></i>
        <h3>Atención</h3>
        <p [innerHTML]="alertMessage"></p>
      </div>
      <div class="modal-footer border-0 justify-content-center d-flex">
        <!-- CAMBIAR: de cancelActionHandler() a confirmActionHandler() -->
        <button type="button" class="btn btn-generalGris" (click)="confirmActionHandler()">Aceptar</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Confirmaciones -->
<div class="modal" id="confirmModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-0"></div>
      <div class="modal-body text-center">
        <i class="bi bi-exclamation-circle" style="color: #19326B;"></i>
        <p [innerHTML]="confirmMessage"></p>
      </div>
      <div class="modal-footer border-0 justify-content-center d-flex">
        <button type="button" class="btn btn-generalGris" (click)="cancelActionHandler()">Cancelar</button>
        <button type="button" class="btn btn-generalAzul2" (click)="confirmActionHandler()">Confirmar</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Respuesta -->
<div class="modal" id="responseModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-0"></div>
      <div class="modal-body text-center">
        <i class="bi bi-check-circle"></i>
        <p [innerHTML]="responseMessage"></p>
      </div>
      <div class="modal-footer border-0 justify-content-center d-flex">
        <button type="button" class="btn btn-generalGris" (click)="confirmActionHandler()">Aceptar</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal para Copiar Enlace DJ -->
<div class="modal" id="copiarLinkModal" [ngClass]="{'show': showCopiarLinkModal}" [ngStyle]="{display: showCopiarLinkModal ? 'block' : 'none', background: 'rgba(0,0,0,0.2)'}" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-0"></div>
      <div class="modal-body text-center">
        <i class="bi bi-check-circle"></i>
        <h3>Enlace para Declaración Jurada</h3>
        <div class="dj-link-container">
          <div class="dj-link-copy-group">
            <input
              type="text"
              class="form-control dj-link-input"
              [value]="copiarLinkUrl"
              readonly
              #djLinkInput
              (click)="seleccionarTexto(djLinkInput)" />
          </div>
          <h6 class="mt-2" style="text-align: justify;">Aquí puede descargar la DJF-NR (formato pdf).</h6>
          <small class="text-muted" style="text-align: justify; display: block;">
            Adicionalmente si lo desea, puede usar el enlace provisto para enviarlo a su cliente, y que el mismo pueda ingresar la información directamente a la plataforma,
          </small>
        </div>
          <button
            type="button"
            class="btn dj-link-copy-btn mt-2 mx-2"
            (click)="copiarLinkAlPortapapeles(djLinkInput)"
            [attr.title]="copiado ? '¡Copiado!' : 'Copiar aquí'">
            <span class="bi" [ngClass]="copiado ? 'bi-clipboard-check' : 'bi-clipboard'"></span>
            {{ copiado ? '¡Enlace Copiado!' : 'Copiar Enlace' }}
          </button>
        <button class="btn btn-generalAzul mt-2 mx-2" (click)="descargarDJ()">
          Descargar DJF-NR
        </button>
        <small class="text-muted pt-3" style="text-align: justify; display: block;">
            o bien, llenarlo usted mismo una vez obtenida la información correspondiente
        </small>
        <button class="btn btn-generalAzul2 mt-2 mx-2" (click)="openDJLink()">
          Ingreso DJF-NR
        </button>
      </div>
      <div class="modal-footer border-0 justify-content-center d-flex">
        <button type="button" class="btn btn-generalGris" (click)="cerrarCopiarLinkModal()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
